import type { StoreActionApi } from 'react-sweet-state';
import type { State } from './types';

export const setShowViewSettingsNudge =
	(showViewSettingsNudge: boolean) =>
	({ setState }: StoreActionApi<State>) => {
		setState({ showViewSettingsNudge });
	};

export const actions = {
	setShowViewSettingsNudge,
} as const;

export type Actions = typeof actions;
